import Embed from './embed';

class CodeEmbed extends Embed {
  static create(value) {
    const domNode = super.create({
      ...value,
      label: 'code',
      customTitle: value.title,
      iconName: 'widgets',
      iconClass: '',
      buttons: ['edit'],
      denseMedia: true,
    });

    domNode.insertAdjacentHTML('beforeend', this.html(value));

    return domNode;
  }

  static html({ html }) {
    return `<div class="ql-code-html">${html}</div>`;
  }

  static value(domNode) {
    return {
      html: domNode.dataset.embedHtml,
      responsive: domNode.dataset.embedResponsive,
    };
  }
}

CodeEmbed.blotName = 'codeEmbed';
CodeEmbed.className = 'ql-code';
CodeEmbed.tagName = 'div';

export default CodeEmbed;
